function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHeartSolid = function SvgHeartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21568"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19851",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17742",
    d: "M3.929 5.929a3.173 3.173 0 0 0 0 4.487l5.417 5.417 5.417-5.417a3.173 3.173 0 0 0-4.487-4.487l-.929.929-.929-.929a3.173 3.173 0 0 0-4.487 0z",
    transform: "translate(.5 -.5)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
};

export default SvgHeartSolid;